var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5989 7.40995C7.17783 7.40995 6.84489 7.65208 6.84489 7.9583C6.84489 8.2574 7.17783 8.50664 7.5989 8.50664H13.4743V11.9107C13.4743 13.6554 11.5257 15.0797 9.11672 15.0797H4.34782C1.94869 15.0797 0 13.6625 0 11.9178V4.00593C0 2.25407 1.95848 0.836914 4.35762 0.836914H9.13631C11.5257 0.836914 13.4743 2.25407 13.4743 3.99881V7.40995H7.5989ZM16.9683 5.49442L19.7787 7.56674C19.923 7.67356 20 7.80887 20 7.95842C20 8.10085 19.923 8.24327 19.7787 8.34297L16.9683 10.4153C16.8239 10.5221 16.6315 10.5791 16.4486 10.5791C16.2561 10.5791 16.0636 10.5221 15.9192 10.4153C15.6305 10.2017 15.6305 9.85271 15.9192 9.63906L17.4592 8.50676H13.4746V7.41007H17.4592L15.9192 6.27777C15.6305 6.06413 15.6305 5.71518 15.9192 5.50154C16.208 5.28078 16.6796 5.28078 16.9683 5.49442Z",
    fill: "#030229"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9aa75d2cae8a506b75840a44e456ba82.svg";
export { ForwardRef as ReactComponent };